import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { App } from "./App";
import { loadConfig, oidcSettings } from "./config";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);

loadConfig()
  .then((config) => {
    const origin = window.location.origin;
    root.render(
      <StrictMode>
        <AuthProvider
          {...oidcSettings(config, origin)}
          // Stays signed in for 30 days in this browser (owner, 2026-11-04); the refresh token renews the session.
          // Sign out clears it.
          userStore={new WebStorageStateStore({ store: window.localStorage })}
          automaticSilentRenew
          onSigninCallback={(user) => {
            // Return to the page asked for before sign-in; only same-site paths are accepted.
            const target = typeof user?.state === "string" && user.state.startsWith("/") && !user.state.startsWith("//")
              ? user.state : "/";
            window.history.replaceState({}, document.title, target);
          }}
        >
          <App config={config} />
        </AuthProvider>
      </StrictMode>,
    );
  })
  .catch((err: unknown) => {
    root.render(
      <main className="page">
        <h1>Portal not configured</h1>
        <p>{err instanceof Error ? err.message : String(err)}</p>
      </main>,
    );
  });
